import {
    ACTION_LOAD_CONTACTS_SUCCESS,
    ACTION_LOAD_CONTACTS_TYPES_SUCCESS, ACTION_SET_CONTACTS_FILTER,
    ContactPickerActionType
} from "./contact-picker.actions";
import {Contact} from "../../business-objects/contact/contact.model";
import {ContactType} from "../../business-objects/contact-type/contact-type.model";

interface IContactTypeOption {
    label: string;
    value: string;
}

export interface IContactPickerItem {
    id: string;
    name: string;
    email: string;
    mobile: string;
    phone: string;
    address: string;
    contactType: string;
}

export interface IFilterFormValue {
    searchTerm: string;
    contactType: string;
}

export interface ContactPickerState {
    contactTypeOptions: Array<IContactTypeOption>;
    contactItems: Array<IContactPickerItem>;
    filterFormValue: IFilterFormValue;
}

export const initialState: ContactPickerState = {
    contactTypeOptions: [],
    contactItems: [],
    filterFormValue: undefined
};

export function reducer(state = initialState, action: ContactPickerActionType): ContactPickerState {
    switch (action.type) {
        case ACTION_LOAD_CONTACTS_SUCCESS: {
            return {
                ...state,
                contactItems: (action.payload as Array<Contact>).map(contact => ({
                    id: contact.id,
                    name: contact.name,
                    email: contact.email,
                    mobile: contact.mobile,
                    phone: contact.phone,
                    address: contact.address,
                    contactType: contact.contactType
                }))
            };
        }
        case ACTION_LOAD_CONTACTS_TYPES_SUCCESS: {
            return {
                ...state,
                contactTypeOptions: (action.payload as Array<ContactType>).map(type => ({
                    label: type.title,
                    value: type.id
                }))
            };
        }
        case ACTION_SET_CONTACTS_FILTER: {
            return {
                ...state,
                filterFormValue: {
                    ...state.filterFormValue,
                    ...action.payload
                }
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/pages/contact-picker/contact-picker.reducer.ts